<template>
  <section class="manager">
    <div v-if="loaded">
      <div>
        <panels></panels>
      </div>
      <div class="page">
        <div class="left">
          <item-list></item-list>
        </div>
        <div class="filters">
          <filters :collapsable="true" key="filter-module"></filters>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Panels from '@/components/Panels'
  import ItemList from '@/components/ItemList'
  import Filters from '@/components/Filters'

  export default {
    name: 'content',
    data () {
      return {}
    },
    computed: {
      ...mapGetters('destiny', ['loaded'])
    },
    components: {Panels, ItemList, Filters},
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm) {
          vm.$store.commit('destiny/profile/selectCharacter', {selectedCharacter: to.params.character})
        }
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.$store.commit('destiny/profile/selectCharacter', {selectedCharacter: to.params.character})
      next()
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "../../styles/settings";

  .manager {
    a {
      color: rgba(255, 206, 31, .8);
    }

    a:hover {
      color: rgba(255, 206, 31, 1);
    }

    .center {
      text-align: center;
    }

    .loading {
      border-top: 4px solid rgba(255, 255, 255, 0);
      border-right: 4px solid rgba(255, 255, 255, .2);
      border-bottom: 4px solid rgba(255, 255, 255, .4);
      border-left: 4px solid rgba(255, 255, 255, .8);
      border-radius: 50%;
      width: 3rem;
      height: 3rem;
      animation: spin 2s linear infinite;

      display: block;
      margin: 3rem auto;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .page {
      max-width: 100vw;
      display: flex;
      .left {
        flex-basis: 420px;
        flex-grow: 1;
      }
      .filters {
        flex-basis: 520px;
        flex-grow: 2;
      }
      @media #{$media-phone} {
        flex-direction: column-reverse;
        .left {
          flex-basis: 100%;
        }
        .filters {
          .checkboxes {
            display: none
          }
          flex-basis: auto;
          // display: none
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Manager.vue?0a09eaf1